import { render, staticRenderFns } from "./Stacks.vue?vue&type=template&id=c20681ee&"
import script from "./Stacks.vue?vue&type=script&lang=js&"
export * from "./Stacks.vue?vue&type=script&lang=js&"
import style0 from "./Stacks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports